// extracted by mini-css-extract-plugin
export default {"label":"form_label__nzG8p","input":"form_input__Xyq7o"};